import React from 'react'
import { TicketSection } from './TicketSection'
import SkeletonTicketComments from '../ticketList/SkeletonTicketComments'
import TicketTimeline from './TicketTimeline'

const TicketActivity = ({ loadingSelectedTicket, ticket_reply, ticket_log, ticket_answer }) => {
  return (
    <TicketSection>
      {loadingSelectedTicket
        ? <div className="mt-2 w-full">
          <SkeletonTicketComments />
        </div>
        : <div>
          <TicketTimeline props={{ ticket_reply, ticket_log, ticket_answer }} />
        </div>
      }
    </TicketSection>
  )
}

export default TicketActivity